import { Modal, Row, Spin } from 'antd';
import styled from 'styled-components';
import { blueDark01, grayDark06 } from '../../../styles/colors';

export const CreateLiveGuidelineModalContainer = styled(Modal)`
    width: 680px !important;

    .ant-modal-body {
        padding: 32px 40px 40px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }

    .ant-input {
        border-radius: 3px;
        border-color: ${grayDark06};
        padding: 7px 10px;
        line-height: 20px;
    }

    textarea.ant-input {
        padding: 7px 8px;
    }

    .ant-form-item-label > label {
        font-weight: 400;
    }
    .live-guideline-name-item .ant-form-item-label > label.ant-form-item-required::before {
        display: none !important;
    }

    .ant-form-vertical .ant-form-item-row {
        gap: 0;
    }

    .ant-form-vertical .ant-form-item-label {
        padding: 0 !important;
        line-height: 16px;
        margin: 0;
    }

    .ant-form-item-label > label {
        line-height: 16px;
    }

    .live-guideline-title {
        font-weight: 400;
        font: 'DIN Next W01 Medium';
    }

    .live-guideline-name-label,
    .live-guideline-description-label {
        margin-bottom: 5px;
        font-family: 'Proxima N W15 Bold';
    }

    .live-guideline-name-label {
        font-weight: 400;
    }

    .live-guideline-name-label .required-mark {
        color: ${blueDark01};
        margin-left: 3px;
        font-weight: 400;
    }

    .live-guideline-name-item {
        width: 260px;
    }

    .live-guideline-description-item.ant-form-item {
        margin-bottom: 24px;
    }

    .live-guideline-primary-button {
        font: 'DIN Next LT Pro';
        padding: 7px 14px;
    }

    .live-guideline-cancel-button {
        display: none;
    }

    .live-guideline-name-item .ant-form-item-explain-error {
        display: none;
    }

    .ant-form-item {
        margin-bottom: 16px;
    }
`;

export const StartProjectRow = styled(Row)`
    .ant-form-item-label
        > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        margin: 0;
    }
    width: 100%;
    gap: 40px;
    margin-bottom: 20px;

    label {
        font-weight: normal;
        font-family: 'Proxima N W15 Bold';
        font-size: 13px !important;
        line-height: 16px !important;
        color: ${blueDark01} !important;
        white-space: nowrap;
    }
`;
export const CreateLiveGuidelineModalSpin = styled(Spin)`
    width: 100%;
`;
